export default class Client {
    constructor (
        _id = 1, 
        _customerType = {}, 
        _dni = "",
        _name = "",
        _lastName = "",
        _email = "",
        _password = "",
        _phone = "",
        _mobile = "",
        _birthday = "",
        _profession = "",
        _hobbie = "",
        _province = { code: "0", name: ''},
        _canton   = { code: "0", name: ''},
        _district = { code: "0", name: ''}, 
        _address  = "",
        _delivery = {}, 
        _whatsapp = 0, 
        _byMail   = 0, 
        _byCall   = 0, 
        _profileUrl = "",
        _status = { id: 1, name: 'Activo' }
    ){
        this.id     = _id;
        this.customerType = _customerType;
        this.name   = _name;
        this.lastName   = _lastName;
        this.profession = _profession;
        this.hobbie   = _hobbie;
        this.dni      = _dni;
        this.email    = _email;
        this.password = _password;
        this.phone    = _phone;
        this.mobile   = _mobile;
        this.birthday = _birthday;
        this.province = _province;
        this.canton   = _canton;
        this.district = _district;
        this.address  = _address;
        this.delivery = _delivery;
        this.whatsapp = _whatsapp;
        this.byMail   = _byMail;
        this.byCall   = _byCall;
        this.profileUrl = _profileUrl;
        this.status  = _status;
    }
}
  